import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTab4Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsProspectsService } from './admissions-prospects.service';
import { AdmissionsProspectsTab1Part } from './tabs/tab-1/admissions-prospects-tab-1.part';
import { AdmissionsProspectsTab2Part } from './tabs/tab-2/admissions-prospects-tab-2.part';
import { AdmissionsProspectsTab3Part } from './tabs/tab-3/admissions-prospects-tab-3.part';
import { AdmissionsProspectsViewsPart } from './views/prospects-views.part';

@Component({
	selector: 'admissions-prospects-page',
	standalone: true,
	imports: [
		AdmissionsProspectsTab1Part,
		AdmissionsProspectsViewsPart,
		AdmissionsProspectsTab2Part,
		AdmissionsProspectsTab3Part,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTab4Directive,
		PageTabsWidget,
		TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-prospects.page.html',
})
export class AdmissionsProspectsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;
	public admissionsService = inject(AdmissionsAreaService);

	constructor(public pageService: AdmissionsProspectsService) { }

	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}